import React from 'react';

import EyeIcon from '@ast/magma/components/icon/icons/Eye';
import EyeSlashIcon from '@ast/magma/components/icon/icons/EyeSlash';

import { Button } from '@ast/magma/components/button';

import { useTranslation } from '@app/core/i18n';

import styles from './styles.pcss';

export interface AccountsDropDownHeaderProps {
  readonly displayHidden: boolean
  readonly hasHidden: boolean
  readonly onClick: () => void
  readonly title: string
}

export const AccountsDropDownHeader: React.FC<AccountsDropDownHeaderProps> = (
  {
    displayHidden,
    hasHidden,
    onClick,
    title,
  },
) => {
  const { t } = useTranslation();
  const ariaLabel = t(
    'toggle-hidden-accounts.aria-label|Aria (accessible) label for show/hide hidden accounts button',
    'Show hidden accounts',
  );

  return (
    <div className={styles.header}>
      <div className={styles.listHeader}>
        {title}
      </div>
      {
        hasHidden && (
          <Button
            aria-label={ariaLabel}
            className={styles.showHideButton}
            data-stable-name="ToggleHiddenAccountsButton"
            icon={displayHidden ? <EyeIcon /> : <EyeSlashIcon />}
            look="icon"
            onClick={(event) => {
              /**
               * this button is displayed in dropdown' container,
               * which using useFocusOut Magma's hook to detect when focus is out,
               * by its own logic.
               * in Safari events are fired in different way comparing with Chrome.
               * by clicking over this button it is not receive focus,
               * and dropdown container lose focus and hides.
               * to prevent it - we manually set focus over that button.
               */
              (event.target as HTMLButtonElement)?.focus();
              onClick();
            }}
            tabIndex={-1}
          />
        )
      }
    </div>
  );
};
